import { Box, Flex, Text, Icon, IconButton, HStack, Image, Tooltip, forwardRef } from '@chakra-ui/react';
import React, { useState, useEffect, useRef } from 'react';
import {
    Copy, MessageCircle, Clock, Truck, Package, TriangleAlert, CircleCheck, ShoppingCart, PackageOpen,
    Ban, CircleDollarSign, CircleAlert, ImageOff, CircleX, Minus, Check, ClipboardList, ClipboardX, Undo2
} from 'lucide-react';
import { DateTime } from "luxon";

export const STATUS_TAGA = {
    1: { texto: "Confirmada", scheme: "green" },
    2: { texto: "Cancelada", scheme: "red" },
    3: { texto: "Pendente", scheme: "yellow" },
};

export const STATUS_MARKETPLACE = {
    "CONFIRMADA": { texto: "Confirmada", scheme: "gray", icone: ShoppingCart },
    "PARA ENVIAR": { texto: "Para enviar", scheme: "orange", icone: Package },
    "EM TRÂNSITO": { texto: "Em trânsito", scheme: "blue", icone: Truck },
    "CONCLUÍDA": { texto: "Concluída", scheme: "green", icone: CircleCheck },
    "CANCELADA": { texto: "Cancelada", scheme: "red", icone: CircleX },
};

export const MARCADORES = {
    1: { texto: "Furo de estoque", scheme: "red", icone: PackageOpen },
    2: { texto: "Venda com pendências", scheme: "yellow", icone: Ban },
    3: { texto: "Problema no envio", scheme: "gray", icone: Truck },
    4: { texto: "Erro de precificação", scheme: "purple", icone: CircleDollarSign },
    5: { texto: "Outros problemas", scheme: "blue", icone: CircleAlert },
    6: { texto: "Produto diferente", scheme: "orange", icone: ImageOff },
};

export const COTACAO = {
    aguardando_envio: { label: "Aguardando envio", scheme: "gray" },
    aguardando_resposta: { label: "Aguardando resposta", scheme: "yellow" },
    sem_estoque: { label: "Sem estoque", scheme: "red" },
    disponivel: { label: "Disponível", scheme: "green" },
};

export const CANAIS = {
    "Mercado Livre": { sigla: "ML", bg: "#FFE600", fg: "#2D3277", nome: "Mercado Livre" },
    "Mercado Shops": { sigla: "MS", bg: "#FFE600", fg: "#2D3277", nome: "Mercado Shops" },
    "ECOMMERCE": { sigla: "SITE", bg: "#F68633", fg: "white", nome: "Venda do site" },
    "TAGA": { sigla: "MANUAL", bg: "#1A202C", fg: "white", nome: "Venda manual" },
    "Magalu": { sigla: "MAGALU", bg: "#0086FF", fg: "white", nome: "Magalu" },
    "Amazon": { sigla: "AMAZON", bg: "#232F3E", fg: "white", nome: "Amazon" },
};

export const CONTAS_ML = {
    1: "Conta 1 ( 48.921.058/0001-02 )",
    2: "Conta 2 ( 48.921.058/0002-85 )",
    3: "Conta 3 ( 48.921.058/0003-66 )",
};

// Bolinha da conta ML; conta sem cor aqui fica azul, como era antes da conta 3.
const COR_CONTA_ML = {
    1: { bg: "yellow.200", borda: "yellow.400" },
    2: { bg: "blue.200", borda: "blue.300" },
    3: { bg: "green.200", borda: "green.400" },
};

export const FORNECEDOR_LOGO = {
    MORELATE: "/logo_morelate.webp",
    ISAPA: "/logo_isapa.webp",
    BRCOMPANY: "/logo_brcompany.webp",
    AUTOLATINA: "/logo_autolatina.webp",
    LNG: "/logo_lng.webp",
    CBA: "/logo_cba.webp",
    MSAM: "/logo_msam.webp",
    BLPARTS: "/logo_blparts.webp",
};

export const LISTA_ICONE = {
    aprovado: CircleCheck,
    parcialmente_aprovado: Check,
    rejeitado: CircleX,
    sem_estoque: TriangleAlert,
    respondido: MessageCircle,
    na_lista: Clock,
    ignorado: Ban,
    sem_status: Minus,
};

export const CONFERENCIA_SELO = {
    0: { texto: "Conferência pendente", icone: ClipboardList },
    2: { texto: "Conferência com problema", icone: ClipboardX },
};

export const NUMEROS = { fontVariantNumeric: 'tabular-nums' };
export const COLUNAS_ITEM = { base: "52px minmax(0,1fr)", md: "60px minmax(0,1fr) 76px 132px", xl: "64px minmax(0,1fr) 70px 112px" };
export const ROLAGEM_ITENS = {
    background: "linear-gradient(white 30%, rgba(255,255,255,0)) top / 100% 24px no-repeat local, linear-gradient(rgba(255,255,255,0), white 70%) bottom / 100% 24px no-repeat local, radial-gradient(farthest-side at 50% 0, rgba(16,24,40,.10), transparent) top / 100% 8px no-repeat scroll, radial-gradient(farthest-side at 50% 100%, rgba(16,24,40,.10), transparent) bottom / 100% 8px no-repeat scroll",
    scrollbarWidth: "thin",
    '&::-webkit-scrollbar': { width: '6px' },
    '&::-webkit-scrollbar-thumb': { background: '#CBD5E0', borderRadius: '6px' },
};

export const linkAnuncioMl = (idMl) => idMl ? `https://produto.mercadolivre.com.br/MLB-${String(idMl).substring(3)}` : null;
export const ROTULO_SECAO = { fontSize: "10px", fontWeight: "700", letterSpacing: "0.08em", textTransform: "uppercase" };
export const LARANJA = "#F68633";
export const COR_ROTULO = "orange.600";
export const FUNDO_LATERAL = "#EEF1F5";
export const SOMBRA = "0 1px 3px rgba(16, 24, 40, 0.08), 0 1px 2px rgba(16, 24, 40, 0.04)";
export const SOMBRA_HOVER = "0 6px 16px -4px rgba(16, 24, 40, 0.10), 0 2px 4px rgba(16, 24, 40, 0.04)";

export const isMercadoLivre = (origem) => origem === "Mercado Livre" || origem === "Mercado Shops";

export const paraNumero = (valor) => {
    if (valor === null || valor === undefined || valor === '') return null;
    const n = typeof valor === 'number' ? valor : Number(String(valor).replace(',', '.'));
    return Number.isFinite(n) ? n : null;
};

export const brl = (valor) => {
    const n = paraNumero(valor);
    return n === null ? '-' : n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
};

export const situacaoPrazo = (data) => {
    if (typeof data !== 'string' || !data.includes(' ')) return "invalido";
    const prazo = DateTime.fromFormat(data, "dd/MM/yyyy HH:mm", { zone: "America/Sao_Paulo" });
    if (!prazo.isValid) return "invalido";
    return prazo < DateTime.now().setZone("America/Sao_Paulo") ? "vencido" : "futuro";
};

export const formatarDocumento = (valor) => {
    const d = String(valor ?? '').replace(/\D/g, '');
    if (d.length === 11) return d.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    if (d.length === 14) return d.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    return valor;
};

export const normalizarTipoCliente = (tipo) => (tipo === 2 || tipo === '2' || tipo === 'PJ') ? 'PJ' : 'PF';

export const DicaSePuder = ({ desativado, children, ...props }) =>
    desativado ? children : <Tooltip openDelay={350} hasArrow placement="top" fontSize="xs" borderRadius="md" {...props}>{children}</Tooltip>;

export const Selo = forwardRef(({ scheme = "gray", forte, icone, ponto, children, ...props }, ref) => (
    <Flex ref={ref} as="span" display="inline-flex" align="center" gap="5px" h="22px" px={2} borderRadius="full" whiteSpace="nowrap"
        fontSize="11px" fontWeight="600" lineHeight="1" sx={NUMEROS}
        bg={forte ? `${scheme}.500` : `${scheme}.50`} color={forte ? "white" : `${scheme}.700`}
        border="1px solid" borderColor={forte ? `${scheme}.500` : `${scheme}.200`} {...props}>
        {ponto && <Box as="span" w="6px" h="6px" borderRadius="full" bg={forte ? "whiteAlpha.900" : `${scheme}.500`} flex="none" />}
        {icone && <Icon as={icone} boxSize="12px" strokeWidth={2.25} flex="none" />}
        {children}
    </Flex>
));

const ICONE_OCORRENCIA = { cancelamento: CircleX, devolucao: Undo2, reembolso: TriangleAlert, reembolsado: CircleCheck, estoque: PackageOpen };

export const SeloOcorrencia = ({ tipo, scheme, forte, onClick, children }) => (
    <Selo as={onClick ? "button" : "span"} type={onClick ? "button" : undefined} cursor={onClick ? "pointer" : "default"} onClick={onClick}
        scheme={scheme} forte={forte} icone={ICONE_OCORRENCIA[tipo]} whiteSpace="normal" h="auto" minH="22px" py="3px" textAlign="left"
        _hover={onClick ? { filter: "brightness(0.97)" } : undefined}>
        {children}
    </Selo>
);

export const LinhaExtrato = ({ rotulo, valor, negativo }) => (
    <Flex justify="space-between" py={0.5}><Text>{rotulo}</Text><Text fontWeight="600" color={negativo ? "red.500" : "gray.800"}>{brl(valor)}</Text></Flex>
);

export const BotaoCopiar = ({ valor, onCopiar, label, tamanho = "13px" }) => {
    const [copiado, setCopiado] = useState(false);
    const timer = useRef(null);
    useEffect(() => () => clearTimeout(timer.current), []);
    const copiar = (e) => {
        e.stopPropagation();
        onCopiar(valor);
        setCopiado(true);
        clearTimeout(timer.current);
        timer.current = setTimeout(() => setCopiado(false), 1500);
    };
    if (copiado) {
        return (
            <Flex as="span" role="status" align="center" gap={1} h="22px" px={1.5} borderRadius="md" bg="green.50" color="green.600" fontSize="11px" fontWeight="600" whiteSpace="nowrap">
                <Icon as={Check} boxSize="12px" strokeWidth={3} />Copiado
            </Flex>
        );
    }
    return (
        <IconButton aria-label={label} size="xs" variant="ghost" color="gray.400" minW="22px" h="22px" borderRadius="md"
            _hover={{ color: "gray.700", bg: "gray.100" }} icon={<Icon as={Copy} boxSize={tamanho} />} onClick={copiar} />
    );
};

export const TextoCopiavel = ({ valor, children, desativarDica, semIcone, ...props }) => {
    const [copiado, setCopiado] = useState(false);
    const timer = useRef(null);
    useEffect(() => () => clearTimeout(timer.current), []);
    const copiar = (e) => {
        e.stopPropagation();
        navigator.clipboard?.writeText(String(valor));
        setCopiado(true);
        clearTimeout(timer.current);
        timer.current = setTimeout(() => setCopiado(false), 1500);
    };
    const conteudo = (
        <Box as="button" type="button" onClick={copiar} aria-label={`Copiar ${valor}`} textAlign="left" cursor="copy" borderRadius="sm" mx="-2px" px="2px"
            color={copiado ? "green.600" : undefined} _hover={{ bg: copiado ? "green.50" : "gray.100" }} transition="background .15s, color .15s" {...props}>
            {children}
            {copiado && !semIcone && <Icon as={Check} boxSize="12px" strokeWidth={3} ml={1} verticalAlign="-1px" color="green.600" />}
        </Box>
    );
    if (desativarDica) return conteudo;
    return (
        <Tooltip label={copiado ? "Copiado" : "Clique para copiar"} hasArrow placement="top" fontSize="xs" borderRadius="md" openDelay={copiado ? 0 : 500}
            bg={copiado ? "green.600" : undefined} isOpen={copiado ? true : undefined}>
            {conteudo}
        </Tooltip>
    );
};

export const Contador = ({ valor }) => (
    <Box position="absolute" top="-5px" right="-5px" bg="red.500" color="white" borderRadius="full" minW="17px" h="17px" fontSize="10px"
        fontWeight="700" display="grid" placeItems="center" px="4px" border="2px solid white" pointerEvents="none" sx={NUMEROS}>
        {valor}
    </Box>
);

export const BotaoAcao = forwardRef(({ label, icone, tom, contador, isMobile, ...props }, ref) => {
    const tons = {
        neutro: { bg: "white", color: "gray.600", borda: "gray.200", hover: "gray.50" },
        laranja: { bg: "orange.50", color: "orange.600", borda: "orange.200", hover: "orange.100" },
    };
    const t = typeof tom === 'object' ? tom : tons[tom || 'neutro'];
    return (
        <Box position="relative" flex="none">
            <IconButton ref={ref} aria-label={label} icon={<Icon as={icone} boxSize="16px" strokeWidth={2} />}
                w={isMobile ? "38px" : "32px"} h={isMobile ? "38px" : "32px"} minW={isMobile ? "38px" : "32px"} borderRadius="lg"
                bg={t.bg} color={t.color} border="1px solid" borderColor={t.borda}
                _hover={{ bg: t.hover }} _active={{ bg: t.hover }} {...props} />
            {contador ? <Contador valor={contador} /> : null}
        </Box>
    );
});

export const Secao = ({ titulo, icone, acao, primeiro, bordaCelular, emLinha, children, ...props }) => (
    <Box px={4} py={3} minW={0} borderColor="gray.200" bg={{ xl: emLinha ? FUNDO_LATERAL : undefined }} {...props}
        borderStyle="solid" borderTopWidth={{ base: "1px", lg: primeiro ? 0 : "1px", xl: emLinha ? 0 : (primeiro ? 0 : "1px") }}
        borderLeftWidth={{ base: bordaCelular ? "1px" : 0, lg: 0, xl: emLinha ? "1px" : 0 }}
        borderRightWidth={0} borderBottomWidth={0}>
        <Flex align="center" justify="space-between" mb={2} h="24px">
            <HStack spacing={1.5} color={COR_ROTULO}>
                <Icon as={icone} boxSize="13px" strokeWidth={2.25} />
                <Text {...ROTULO_SECAO}>{titulo}</Text>
            </HStack>
            {acao}
        </Flex>
        {children}
    </Box>
);

export const LinhaContato = ({ icone, children }) => (
    <HStack spacing={2} align="flex-start" minW={0}>
        <Icon as={icone} boxSize="13px" color="gray.400" mt="2px" flex="none" />
        <Text fontSize="12px" color="gray.700" minW={0} wordBreak="break-word" sx={NUMEROS}>{children}</Text>
    </HStack>
);

export const CANAL_LOGO = {
    "Mercado Livre": "/ml_logo_2.webp",
    "Mercado Shops": "/ms_logo.webp",
    "Magalu": "/magalu-logo.webp",
    "Amazon": "/amazon-logo.webp",
};

export const Canal = ({ pedido, isMobile }) => {
    const canal = CANAIS[pedido.origem];
    if (!canal) return null;
    const ehMl = isMercadoLivre(pedido.origem);
    const dica = ehMl ? `${canal.nome} · ${CONTAS_ML[pedido.conta] || `Conta ${pedido.conta}`}` : canal.nome;
    const ehTaga = pedido.origem === "TAGA" || pedido.origem === "ECOMMERCE";
    const corConta = COR_CONTA_ML[Number(pedido.conta)] || COR_CONTA_ML[2];
    return (
        <DicaSePuder desativado={isMobile} label={dica}>
            <HStack as="span" spacing={1.5} flex="none">
                {ehTaga ? (
                    <Image loading="lazy" decoding="async" src="/taga_logo.jpg" alt="TAGA" boxSize="26px" borderRadius="md" objectFit="cover" />
                ) : (
                    <Flex align="center" h={ehMl ? { base: "26px", md: "32px" } : "26px"} px={pedido.origem === "Amazon" ? 1.5 : 0} bg="white" borderRadius="md" overflow="hidden" border="1px solid" borderColor="blackAlpha.100">
                        <Image loading="lazy" decoding="async" src={CANAL_LOGO[pedido.origem]} alt={canal.nome} h={pedido.origem === "Amazon" ? "16px" : "100%"} w="auto" />
                    </Flex>
                )}
                {ehMl && pedido.conta && (
                    <Box w="20px" h="20px" borderRadius="full" display="grid" placeItems="center" fontSize="11px" fontWeight="800" color="gray.800"
                        bg={corConta.bg} border="1px solid" borderColor={corConta.borda}>
                        {pedido.conta}
                    </Box>
                )}
                {ehTaga && (
                    <Text as="span" fontSize="10px" fontWeight="800" letterSpacing="0.06em" color="gray.600">{canal.sigla}</Text>
                )}
            </HStack>
        </DicaSePuder>
    );
};
